@if (false) {
<!-- <my-content placeholder="navigation"> -->
  <!-- <div class="user-master-page"> -->

    <!-- Modal -->

    <!-- <div class="divider"></div> -->

    <!-- Search + top actions -->
    <!-- <label class="col-sm-3 control-label search-label">Search</label> -->
    <!-- <div class="card toolbar-card"> -->
      <!-- <div class="row"> -->
        <!-- <div class="col-sm-6">
          <form #SearchEmployee="ngForm" [formGroup]="FormSearchEmployee"
            (ngSubmit)="onSearchEmployee(SearchEmployee.value)" class="search-form">
            <div class="form-horizontal">
              <div class="form-group no-margin">
                <div class="col-sm-6">
                  <input class="form-control" formControlName="txtSearch" placeholder="Search by name, email, role..."
                    name="txtSearch" type="text" />
                </div>
                <div class="col-sm-2">
                  <button class="btn btn-primary btn-block" type="submit">
                    Go
                  </button>
                </div>
                <div class="col-4"></div>
              </div>
            </div>
          </form>
        </div> -->

        <!-- <div class="col-sm-3"></div> -->

        <!-- <div class="col-sm-3 text-right"> -->
          <!-- <div class="action-buttons"> -->
            <!-- Add user (rights + capacity check) -->
            <!-- <div *ngIf="
                  this.RightsID.includes('202040021') && this.UserCondition == 1;
                  then AddUserLink;
                  else AddUser
                "></div> -->

            <!-- <ng-template #AddUserLink>
              <button type="button" class="btn-icon" title="Create New Employee" data-toggle="modal"
                data-target="#ModalPopUP"
                (click)="OpenModal('add-user-master','0','Create User Master','FetchUserMaster');">
                <i class="material-icons">add</i>
              </button>
            </ng-template> -->

            <!-- <ng-template #AddUser> -->
              <!-- No add button when no rights / limit reached -->
            <!-- </ng-template> -->

            <!-- User listing -->
            <!-- <a href="#/report/207047000" class="btn-icon" title="User Listing">
              <i class="fa fa-list"></i>
            </a> -->
          <!-- </div> -->
        <!-- </div> -->
      <!-- </div> -->
    <!-- </div> -->

    <!-- Usage summary cards -->
    <!-- <div class="row stats-row">
      <div class="col-sm-4">
        <div class="stat-card">
          <div class="stat-title">Active Paid User</div>
          <div class="stat-value">
            {{ this.ConsumedPaidUser }}/{{ this.AllocateUser }}
          </div>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="stat-card">
          <div class="stat-title">Active Un-Paid User</div>
          <div class="stat-value">
            {{ this.ConsumedUser }}/{{ this.AllocateUnPaidUser }}
          </div>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="stat-card">
          <div class="stat-title">Active Total User</div>
          <div class="stat-value">
            {{ this.totalConsumed }}/{{ this.totalUser }}
          </div>
        </div>
      </div>
    </div> -->

    <!-- Messages -->
    <!-- <div *ngIf="MsgType === 2" class="alert alert-info alert-sm">
      {{ DisplayMessage }}
    </div>
    <div *ngIf="MsgType === 3" class="alert alert-danger alert-sm">
      {{ DisplayMessage }}
    </div> -->

    <!-- Employee table -->
    <!-- <div class="panel panel-default employees-panel">
      <div class="panel-heading">
        <div class="row">
          <div class="col-sm-6">
            <h4 class="panel-title">
              <i class="fa fa-users header-icon"></i>
              Manage Employees
            </h4>
          </div>
        </div>
      </div> -->

      <!-- <div class="panel-body panel-body-table">
        <div class="table-responsive">
          <table class="table table-striped table-hover table-bordered">
            <thead>
              <tr>
                <th>S.N.</th>
                <th>Employee Name</th>
                <th>Login Name</th>
                <th>Designation</th>
                <th>Email</th>
                <th>Mobile</th>
                <th>Manager</th>
                <th>Role</th>
                <th>Password</th>
                <th>Status</th>
                <th class="text-center">Action</th>
              </tr>
            </thead> -->

            <!-- Show data -->
            <!-- <tbody *ngIf="UserDetail && UserDetail.length; else noData">
              <tr *ngFor="
                    let UserDetails of UserDetail
                      | paginate: { itemsPerPage: 10, currentPage: pageNumber };
                    let i = index
                  "> -->
                <!-- <td>{{ (pageNumber - 1) * 10 + i + 1 }}</td>
                <td>{{ UserDetails.UserName }}</td>
                <td>{{ UserDetails.LoginName }}</td>
                <td>{{ UserDetails.DesignationName }}</td>
                <td>{{ UserDetails.Email }}</td>
                <td>{{ UserDetails.Mobile }}</td>
                <td>{{ UserDetails.Manager }}</td>
                <td>{{ UserDetails.Role }}</td> -->

                <!-- Password -->
                <!-- <td>
                  <ng-container *ngIf="UserDetails.IsPaid == '1'; else noPassword">
                    <div class="form-group" *ngIf="
                          this.RightsID.includes('202040021');
                          then ChangePasswordLink;
                          else ChangePassword
                        "></div>

                    <ng-template #ChangePasswordLink>
                      <a data-toggle="modal" title="Change Password" data-target="#ModalPopUP"
                        (click)="OpenModal('setpassword',UserDetails.ID,'Set Password','FetchUserMaster');">
                        <i class="icon-lock font-16 theme-icon"></i>
                      </a>
                    </ng-template>

                    <ng-template #ChangePassword>
                      <a href="module/0" title="Change Password">
                        <i class="icon-lock font-16 theme-icon"></i>
                      </a>
                    </ng-template>
                  </ng-container>

                  <ng-template #noPassword>
                    <span class="text-muted">—</span>
                  </ng-template>
                </td> -->

                <!-- Status -->
                <!-- <td>{{ UserDetails.status }}</td> -->

                <!-- Actions -->
                <!-- <td class="action-column text-center"> -->
                  <!-- Edit -->
                  <!-- <span class="inline-actions" *ngIf="
                        this.RightsID.includes('202040021');
                        then EditUserLink;
                        else EditUser
                      "></span>

                  <ng-template #EditUserLink>
                    <a data-toggle="modal" title="Edit" data-target="#ModalPopUP"
                      (click)="OpenModal('add-user-master',UserDetails.ID,'Create User Master','FetchUserMaster');">
                      <i class="fa fa-pencil font-16 theme-icon"></i>
                    </a>
                  </ng-template>

                  <ng-template #EditUser>
                    <a href="module/0" title="Edit">
                      <i class="fa fa-pencil font-16 theme-icon"></i>
                    </a>
                  </ng-template>

                  <span class="action-separator"></span> -->

                  <!-- Delete -->
                  <!-- <span class="inline-actions" *ngIf="
                        this.RightsID.includes('202040021');
                        then DeleteUserLink;
                        else DeleteUser
                      "></span>

                  <ng-template #DeleteUserLink>
                    <a (click)="DeleteUserMaster(UserDetails.ID)" title="Delete">
                      <i class="fa fa-trash text-danger cursor-pointer font-16"></i>
                    </a>
                  </ng-template>

                  <ng-template #DeleteUser>
                    <a href="module/0" title="Delete">
                      <i class="fa fa-trash text-danger cursor-pointer font-16"></i>
                    </a>
                  </ng-template> -->
                <!-- </td> -->
              <!-- </tr> -->
            <!-- </tbody> -->

            <!-- No data -->
            <!-- <ng-template #noData>
              <tbody>
                <tr>
                  <td colspan="11" class="text-center text-muted">
                    {{ DisplayMessage || 'No employees found' }}
                  </td>
                </tr>
              </tbody>
            </ng-template>
          </table>
        </div>
      </div>

      <div class="panel-footer">
        <div class="pagination-wrapper">
          <pagination-controls (pageChange)="pageNumber = $event"></pagination-controls>
        </div>
      </div>
    </div> -->

    <!-- Hidden auto-close option (left as-is) -->
    <!-- <div class="form-group mt-2" style="display:none;">
        <div class="form-check">
          <input
            type="checkbox"
            name="autoClose"
            id="autoClose"
            class="form-check-input"
            checked="true"
            [(ngModel)]="options.autoClose"
          />
          <label for="autoClose">Auto close alert after three seconds</label>
        </div>
      </div> -->
  <!-- </div> -->
<!-- </my-content> -->

<!-- <my-content placeholder="main">
</my-content> -->
} @else {
<div id="ModalPopUP" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
  <div [class]="modaldialog">
    <div class="modal-content">
      <div class="modal-header BlueHeader">
        <h4 class="Heading">{{ModelFor}}</h4>
        <button type="button" class="close" (click)="this[CallFunctionOnCloseModal]()" data-dismiss="modal">
          &times;
        </button>
      </div>
      <div class="modal-body form-group">
        <iframe width="100%" [height]="height" frameBorder="0" [src]="modalURL | safe"></iframe>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid">
  <div class="table-header-container">
    <div class="table-heading">
      Manage Employees
    </div>
    <form [formGroup]="FormSearchEmployee" (ngSubmit)="onSearchEmployee(FormSearchEmployee.value)">
      <div class="d-flex">
        <div class="input-group">
          <input type="text" placeholder="Search here..." class="table-search-input form-control"
            formControlName="txtSearch">
          <span class="input-group-btn">
            <button class="btn btn-primary" title="Search">
              <i class="fas fa-magnifying-glass"></i>
            </button>
          </span>
        </div>
        <button class="btn btn-outline-primary mx-2" title="Create New Employee" data-toggle="modal"
          data-target="#ModalPopUP" (click)="OpenModal('add-user-master','0','Create User Master','FetchUserMaster');">
          <i class="fas fa-plus"></i>
        </button>
        <button class="btn btn-outline-primary " routerLink="/report/207047000" target="_blank">
          <i class="fas fa-list"></i>
        </button>
      </div>
    </form>
  </div>
  <div class="d-flex align-items-center justify-content-between my-3">
    <div class="active-user-card d-flex">
      <div class="card-left w-100 p-4">
        <img class="card-icon" src="../../../assets/icons/active-user-icon.svg" alt="">
        <div class="card-title mt-2">Active Paid User</div>
        <div class="card-count">
          {{ ConsumedPaidUser }}/{{ AllocateUser }}
        </div>
      </div>
      <div class="card-right">
        <img class="card-bg-icon" src="../../../assets/icons/active-user-bg-icon.svg" alt="">
      </div>
    </div>
    <div class="revenue-card d-flex">
      <div class="card-left w-100 p-4">
        <img class="card-icon" src="../../../assets/icons/revenue-icon.svg" alt="">
        <div class="card-title mt-2">Other Revenue</div>
        <div class="card-count">
          {{ ConsumedUser }}/{{ AllocateUnPaidUser }}
        </div>
      </div>
      <div class="card-right">
        <img class="card-bg-icon" src="../../../assets/icons/revenue-bg-icon.svg" alt="">
      </div>
    </div>
    <div class="total-user-card d-flex">
      <div class="card-left w-100 p-4">
        <img class="card-icon" src="../../../assets/icons/total-user-icon.svg" alt="">
        <div class="card-title mt-2">Total Active User</div>
        <div class="card-count">
          {{ totalConsumed }}/{{ totalUser }}
        </div>
      </div>
      <div class="card-right">
        <img class="card-bg-icon" src="../../../assets/icons/total-user-bg-icon.svg" alt="">
      </div>
    </div>
  </div>
  <div class="card table-container">
    <table class="custom-table">
      <thead>
        <tr>
          <th>S.N.</th>
          <th>Employee Name</th>
          <th>Login Name</th>
          <th>Designation</th>
          <th>Email</th>
          <th>Mobile</th>
          <th>Manager</th>
          <th>Role</th>
          <th>Password</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <app-table-state [loading]="MsgType == 1"
          [error]="MsgType == 3 ? DisplayMessage ?? 'Something went wrong while fetching data.' : null"
          [empty]="filteredData?.length == 0" [rows]="10" [columns]="11">
        </app-table-state>
        @if (filteredData?.length>0) {
        @for (UserDetails of filteredData | paginate : { itemsPerPage: pageSize, currentPage: pageNumber }; track $index ; let i
        = $index) {
        <tr>
          <td>{{ (pageNumber - 1) * pageSize + i + 1 }}</td>
          <td>{{ UserDetails.UserName }}</td>
          <td>{{ UserDetails.LoginName }}</td>
          <td>{{ UserDetails.DesignationName }}</td>
          <td>{{ UserDetails.Email }}</td>
          <td>{{ UserDetails.Mobile }}</td>
          <td>{{ UserDetails.Manager }}</td>
          <td>{{ UserDetails.Role }}</td>

          <!-- Password -->
          <td>
            @if (UserDetails.IsPaid == '1') {
            @if (RightsID.includes('202040021')) {
            <a data-toggle="modal" title="Change Password" data-target="#ModalPopUP" (click)="OpenModal(
                            'setpassword',
                            UserDetails.ID,
                            'Set Password',
                            'FetchUserMaster'
                          )">
              <i class="icon-lock font-16 theme-icon"></i>
            </a>
            } @else {
            <a href="module/0" title="Change Password">
              <i class="icon-lock font-16 theme-icon"></i>
            </a>
            }

            }
          </td>

          <!-- Status -->
          <td>
            <button class="status-btn" [class.enable]="UserDetails.status === 'Enable'"
              [class.disable]="UserDetails.status === 'Disable'">
              {{ UserDetails.status }}
            </button>
          </td>

          <!-- Actions -->
          <td class="action-column text-center">

            <!-- Edit -->
            @if (RightsID.includes('202040021')) {
            <button class="icon-btn icon-btn-primary" title="Edit" data-toggle="modal" data-target="#ModalPopUP"
              (click)="OpenModal(
                            'add-user-master',
                            UserDetails.ID,
                            'Create User Master',
                            'FetchUserMaster'
                          )">
              <i class="fa fa-pencil"></i>
            </button>
            } @else {
            <button class="icon-btn icon-btn-primary" href="module/0" title="Edit">
              <i class="fa fa-pencil"></i>
            </button>
            }

            <span class="action-separator"></span>

            <!-- Delete -->
            @if (RightsID.includes('202040021')) {
            <button class="icon-btn icon-btn-danger mx-2" (click)="DeleteUserMaster(UserDetails.ID)" title="Delete">
              <i class="fa fa-trash"></i>
            </button>
            } @else {
            <button class="icon-btn icon-btn-danger mx-2" href="module/0" title="Delete">
              <i class="fa fa-trash"></i>
            </button>
            }
          </td>
        </tr>
        }
        }
      </tbody>
    </table>
  </div>
    @if (filteredData?.length > 0) {
      <div class="d-flex justify-content-between my-3 w-100">
          <div class="w-50">
              <app-rows-per-page
              [pageSize]="pageSize"
              [total]="totalRecords"
              [pageIndex]="pageNumber"
              (pageSizeChange)="onPageSizeChange($event)">
          </app-rows-per-page>
          </div>
          <pagination-controls (pageChange)="pageNumber = $event"></pagination-controls>
      </div>
  }
  <!-- @if (filteredData?.length > 0) {
  <div class="d-flex justify-content-end my-3">
    <pagination-controls (pageChange)="pageNumber = $event"></pagination-controls>
  </div>
  } -->
</div>
}